import { BcmOrder, BcmOrderDto } from './bcm-order';
import { InvoicePosition } from './invoice-position';

export interface BcmOrderInvoicePositionDto {
    id: number;
    bcm_orders_id: number;
    bcm_invoice_positions_id: number;
    bcm_order_work_packages_id?: number | null;
    insertedOn: Date;
    insertedBy: string;
    lastUpdateOn: Date;
    lastUpdateBy: string;
    order: BcmOrderDto;
    invoicePosition: InvoicePosition;
}

export class BcmOrderInvoicePosition {
    id: number;
    bcm_orders_id: number;
    bcm_invoice_positions_id: number;
    bcm_order_work_packages_id?: number | null;
    readonly insertedOn: Date;
    readonly insertedBy: string;
    readonly lastUpdateOn: Date;
    readonly lastUpdateBy: string;
    order!: BcmOrder;
    invoicePosition!: InvoicePosition;

    constructor(bcmOrderAttachment: BcmOrderInvoicePositionDto) {
        this.id = bcmOrderAttachment.id;
        this.bcm_orders_id = bcmOrderAttachment.bcm_orders_id;
        this.bcm_invoice_positions_id = bcmOrderAttachment.bcm_invoice_positions_id;
        this.bcm_order_work_packages_id = bcmOrderAttachment.bcm_order_work_packages_id ?? null;
        this.insertedOn = bcmOrderAttachment.insertedOn;
        this.insertedBy = bcmOrderAttachment.insertedBy;
        this.lastUpdateOn = bcmOrderAttachment.lastUpdateOn;
        this.lastUpdateBy = bcmOrderAttachment.lastUpdateBy;

        this.order = new BcmOrder(bcmOrderAttachment.order);
        this.invoicePosition = bcmOrderAttachment.invoicePosition;
    }
}

